// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appLocalLeft
{
    float: left;

    width: 220px;
    height: 100%;
    margin-left: 10px;
    
}


.appLocalRight
{
    float: left;
    margin-left: 15px;
    width: calc(97% - 235px);
    height: 100%;
    
}`, "",{"version":3,"sources":["webpack://./src/applications/appstyles/local.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;;IAEX,YAAY;IACZ,YAAY;IACZ,iBAAiB;;AAErB;;;AAGA;;IAEI,WAAW;IACX,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;;AAEhB","sourcesContent":[".appLocalLeft\n{\n    float: left;\n\n    width: 220px;\n    height: 100%;\n    margin-left: 10px;\n    \n}\n\n\n.appLocalRight\n{\n    float: left;\n    margin-left: 15px;\n    width: calc(97% - 235px);\n    height: 100%;\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
